import {
  addMonths,
  format,
  formatDistanceToNow,
  subDays,
  subMonths,
} from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), "MMM-dd-yyyy");
}

export function fDate1(date) {
  return format(new Date(date), "yyyy-MM-dd");
}

export function fDateTime(date) {
  return format(new Date(date), "MMM-dd-yyyy HH:mm");
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), "dd/MM/yyyy hh:mm p");
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}
export function fDate12(date) {
  return format(new Date(date), "MMM-dd-yyyy  p");
}

export function getPastDate(day) {
  const currentDate = new Date();
  const pastDate = subDays(currentDate, day);
  return format(pastDate, "MM/dd/yyyy");
}
export function getcurrentDate(day) {
  const currentDate = new Date(); // Get the current date
  // const pastDate = subDays(currentDate, daysAgo); // Subtract the specified number of days
  return format(currentDate, "MM/dd/yyyy"); // Format the past date
}

export function getBeforeDate(day) {
  const currentDate = new Date();
  //const pastDate = subDays(currentDate, day);
  const minDate = subDays(new Date(), 30); // 30 days ago
  return format(minDate, "MM/dd/yyyy");
}
